export const locale = {
  lang: {
    russian: "Русский",
    uzbekLatin: "O‘zbek (Lotin)",
    uzbekKrill: "Ўзбек (кирилл)",
    kr : "Qaraqalpaq (latın)"
  },
  lotin: " (латинский)",
  search: "Поиск",
  obnamuna: "Обективка намунаси",
  photoCan: "Фотография кандидата",
  selectedVakant: "Избранные вакансии",
  staff_requirement_1: "Направление и функции позиции",
  staff_requirement_2: "официальные требования к должности",
  with_me: "С нами вы можете добиться следующих результатов",
  staff_requirement_card_1: "Барча меҳнат шароитлари яратилган замонавий идора",
  staff_requirement_card_2: "Замонавий фикрлайдиган ва аҳил меҳнат жамоаси",
  staff_requirement_card_3:
    "Муносиб иш ҳақи (махсус унвон-мартаба даражаси, иш стажи, ойлик шахсий устама ва бошқа қўшимчалар)",
  staff_requirement_card_4:
    "Ишончли хизмат карьераси, юқори лавозимларга кўтарилиш имконияти",
  staff_requirement_card_5:
    "Профессионал ходимлар орасида катта иш тажрибаси ва бебаҳо касбий кўникмаларни орттириш имконияти",
  staff_requirement_card_6:
    "Xорижда малака ошириш ва стажировка ўташ имконияти",
  home: {
    menuText1: "Вакансии в министерстве юстиции,",
    menuText2: "в органах и учреждениях юстиции",
    search: "министерство, органы и учреждения юстиции",
    countEnnounment: "Количество объявлений",
    searchRegion: "Поиск по региону",
    searchJob: "Поиск по должности",
    statistic: "Статистика",
    vacancyCount: "Объявлений",
    vacancies: "Свободные места",
    applicants: "Претенденты",
    recruited: "Набранные",
    lavozim: "Должность",
    vacancy: "Вакансия",
    company: "Министерство юстиции Республики Узбекистан",
    havola: "Наши адреса",
    nomzod: "Кандидаты",
    close: "Закрывать",
    sendDocument: "Отправка документов",
    aboutLavozim: "Общая информация",
    aboutAll: "о должности",
    vazirlik: "Министерство",
    bolim: "Управление(pаздел)",
    lavozimToifa: "Категория должности",
    jobOn: "Вакансия",
    createDate: "Дата анонса",
    finishDate: "Срок действия объявления",
    modalTitle:"После получения ID-карты, обновите свои данные в системе OneID",
    skipping: "Пропуская",
    updateInformation: 'Обновить информацию'
  },
  status: "Статус",
  seriaNumber: "Серия и номер паспорта",
  secury: {
    fullMsg:
      "Пароль должен состоять как минимум из 8 символов, одной строчной буквы, одной прописной буквы, одной цифры и одного специального символа.",
    msg1: "Пароль",
    msg2: "минимум 8 символов ",
    msg3: "одна цифра ",
    msg4: "от одной строчной буквы ",
    msg5: "с одной заглавной буквы ",
    msg6: "из одного специального символа ",
    msg7: " должен состоять из.",
    msg8: "Не используйте кириллицу",
    successPswdSecury: "Пароль принят.",
    successNoPswdSecury: "Пароль не принят.",
  },
  usernameAlready: "Такое имя пользователя уже существует",
  isSaved: "Вы сохранете введенные данные?",
  messages: "Xabarlar",
  org: "Организация",
  annoucement: "Объявления",
  additionalDoc: "Загрузить дополнительные документы",
  expireDateMessage: "Срок сдачи теста истек",
  pasportInfo: "Паспортные данные",
  finishSure: "Вы уверены, что закончите тест",
  testAnswers: "Тестовые ответы",
  expiredDate: "Дата истечения срока действия",
  givenDate: "Дата выдачи",
  createdDate: "Дата создания",
  variantlar: "Варианты",
  inPercent: "Тестовый ответ в процентах",
  result: "Результат",
  testResult: "Результаты теста",
  doc: "Документы",
  nameDoc: "Название документа",
  allTest: "Общее количество вопросов",
  EmployeeFIO: "Кандидат",
  allTestCorrect: "Количество правильных ответов",
  allTestNoCorrect: "Количество неправильных ответов",
  showArizaInfo: "Заявка кандидата",
  forLogin: "Чтобы залогиниться",
  status: {
    PASSED_TEST: "Тест пройден успешно",
    FAILED_TEST: "Не удалось пройти тест",
    TEST: "Пройти тест",
    MEETING: "Собеседование с кандидатом",
    SEND_DOCUMENT: "Документы отправлены",
    SEEN: "Кандидатские документы рассмотрены",
    REGISTERED: "Кандидат зарегистрирован",
    CONTRACT: "Договор",
    NOT_ACCEPTED: "Не принял",
    TEST_PROCESS: "Тест начался",
    PASSED_MEETING: "Прошёл собеседования",
    FAILED_MEETING: "Не прошёл собеседования",
  },
  warning: {
    enter: "Данные должны быть введены полностью",
    finishTest: "Время тестирования закончилось",
    noInformation: "Данные не найдены",
    noChoosen: "Нет выбора файла",
    noInfo: "Если у вас нет информации",
    dataIncomplate: "Пожалуйста, введите информацию правильно",
    tokenExpired: "Срок действия токена истек",
    sure: "Вы уверены",
    notSaved: "Возможно, внесенные изменения не сохранятся",
    successReg: "Вы успешно зарегистрировались",
    warInfo: "Заполните информацию в личном кабинете",
    selectInfo: "Вы подали заявку на вакансию по этому объявлению",
    loginInfo:
      "Ҳужжат юборишдан олдин шахсий кабинетингизга кирган бўлишингиз керак!",
  },
  percent: {
    title: "Процент",
    sign: "%",
  },
  allowance: {
    percent: "Процентов %",
    department: "Отделы",
  },
  succes: {
    SEND_DOCUMENT: "Документы отправлены",
    saved: "Успешно спасен",
    createEmployee: "Сотрудник успешно создан!",
  },
  numberAnnounsment: "Номер объявления",
  candidates: "Кандидаты",
  orderNumber: "Порядковый номер",
  transliteratsiya: "Транслитерация",
  types: "Типы",
  dashboard: "Меню",
  total: "Общее",
  empty: "Пустой",
  other: "Другой",
  recentActivity: "Недавняя активность",
  login: {
    videoInfo: "Подача документов на конкурс",
    videoLesson: "видео-гид по",
    email: "Эл. адрес",
    verify: "Проверить",
    phone: "Телефон",
    byToken: " Войти с помощью ключа ",
    username: "Имя пользователя",
    password: "Пароль",
    title: "Вход в систему",
    account: "Войдите в свой аккаунт",
    come_out: "Войти",
    come_up: "Выйти",
    update: "Изменить пароль",
    userProfile: "Профиль пользователя",
    currentPassword: "Текущий пароль",
    newPassword: "Новый пароль",
    confirmPassword: "Подтвердите Пароль",
    misMatch: "Текущее несоответствие пароля",
    inn: "ИНН",
    fio: "Ф.И.О",
    org: "Организация",
    srokLicence: "Срок действия сертификата",
    numberLicence: "№ Сертификата",

    forgetPassword: "Забылы пароль?",
    enteredInfo: "Личное ввод данных",
    ByregisteredInfo:
      "Введите адрес электронной почты или номер телефона, который вы использовали при регистрации",
    forgetPasswordTitle:
      "В целях безопасности мы должны убедиться, что это действительно вы. Пожалуйста, повторно введите свою личную информацию ниже, чтобы продолжить.",
    forgetTitle: "Введите одну из ваших личных данных ниже",
    byusername: "Имя пользователя",
    bypassport: "Серия и номер паспорта",
    Byregistered:
      "Выберите адрес электронной почты или номер телефона, который вы использовали при регистрации",
    sendConfirmCode: "Введите отправленный код подтверждения и новый пароль",
    confirmCode: "Код для подтверждения",
    newPasswordEntered: "Новый пароль",
    forgetConfirm: "Подтверждение",

    or: "Или",
    account: "Cоздать account",
    registration: "Регистрация",
    oferta: "Я принимаю условия публичной оферты",
    accountYes: "Уже есть аккаунт?",
    verifiyCodeWhere: "Куда отправить проверочный код?",
    entered: " вводите",
    yourDid: "Вы сделали это!",
  },
  register: {
    text: {
      text1:
        "АДЛИЯ ОРГАНЛАРИ ВА МУАССАСАЛАРИДА ХОДИМЛАРНИ ИШГА ҚАБУЛ ҚИЛИШ ТАРТИБИ",
      text2: "Умумий қоидалар",
      text3:
        "Адлия органлари ва муассасаларига жинси, ёши, ирқи, миллати, тили, ижтимоий\n" +
        "                келиб чиқиши, мулкий ҳолати ва мансаб мавқеи, динга бўлган муносабати, эътиқоди,\n" +
        "                жамоат бирлашмаларига мансублигидан қатъи назар, ўзининг касбий, ишчанлик, шахсий\n" +
        "                ва ахлоқий фазилатлари, маълумоти даражаси ва соғлиғига кўра адлия органлари\n" +
        "                ва муассасаларига юклатилган вазифаларни бажаришга қодир бўлган Ўзбекистон\n" +
        "                Республикаси фуқаролари ёки Ўзбекистон Республикаси Президентининг алоҳида\n" +
        "                қарорлари билан ўрнатилган тартибда хорижий давлатларнинг фуқаролари ва фуқаролиги\n" +
        "                бўлмаган шахслар қабул қилинади.",
      text4:
        "Қуйидагилар адлия органлари ва муассасаларига ишга қабул қилиниши мумкин эмас:",
      text5: "- ўн олти ёшга тўлмаган шахслар;",
      text6:
        "- белгиланган тартибда муомалага лаёқатсиз ёки муомала лаёқати чекланган\n" +
        "                деб топилган шахслар;",
      text7:
        "- адлия органи ёки муассасасининг ишлаб турган ходими билан яқин қариндош\n" +
        "                ёки қуда-анда бўлса (ота-оналар, ака-укалар, опа-сингиллар, фарзандлар, эр-хотинлар, шунингдек\n" +
        "                эр-хотинларнинг ота-оналари, ака-укалари, опа-сингиллари ва фарзандлари), агар ишга қабул қилинаётган\n" +
        "                ёки тайинланаётган лавозим улардан бири иккинчисига бевосита бўйсуниб ёки унинг назорати остида хизмат\n" +
        "                қилишни тақозо қилса;",
      text8:
        "- ишга кириш учун сохта ҳужжатлар ёки била туриб ёлғон маълумотлар тақдим этган бўлса;",
      text9:
        "- судланганлик ҳолати тугалланмаган ёки судланганлиги олиб ташланмаган шахслар;",
      text10: "- қонун ҳужжатларида белгиланган бошқа ҳолатлар.",
      text11:
        "Адлия органлари ва муассасаларига ходимларни ишга қабул қилиш бўйича танлов адлия органлари ва\n" +
        "                муассасаларининг кадрлар таркибини ишчанлик, шахсий ва ахлоқий фазилатлари, маълумоти даражаси ва\n" +
        "                соғлиғига кўра юклатилган вазифа ва функцияларни бажаришга лаёқатли бўлган ходимлар билан таъминлаш\n" +
        "                мақсадида ўтказилади.",
      text12:
        "Танлов адлия органлари ва муассасаларининг раҳбарлари томонидан ташкил\n" +
        "                этиладиган камида 5 нафар ходимларидан иборат махсус комиссия томонидан\n" +
        "                меритократия, очиқлик ва мустақиллик тамойиллари асосида ўтказилади.Келишувга асосан ҳуқуқни муҳофаза\n" +
        "                қилувчи органлар, суд ва нодавлат нотижорат ташкилотлари ҳамда жамоатчилик вакиллари комиссия таркибига\n" +
        "                киритилиши мумкин.",
      text13:
        "Махсус комиссия йиғилиши аъзоларининг камида 2/3 (учдан икки) қисми қатнашган тақдирда ваколатли\n" +
        "                ҳисобланади.",
      text14: "Танлов босқичлари",
      text15: "Танлов қуйидаги босқичлардан иборат:",
      text16:
        "1. Бўш иш ўрнига ҳужжат топширган номзодларни дастлабки ўрганиш;",
      text17: "2. Тест синови;",
      text18:
        "3. Номзод билан унинг назарий билимлари ва касбий лаёқатини аниқлаш юзасидан суҳбат ўтказиш.",
      text19:
        "Танлов жараёнлари ўтказилаётган жойда Махсус комиссия аъзолари, Ишчи орган вакиллари ва номзоддан\n" +
        "                ташқари бегона шахсларнинг ҳозир бўлишига рухсат берилмайди.",
      text20: "Танловда иштирок этиш учун талаблар",
      text21:
        "Танловда иштирок этиш истагини билдирган номзод Адлия вазирлигнинг\n" +
        "                vacancy.adliya.uz сайти орқали рўйхатдан ўтиб, номзоднинг шахсий варақаси (сўровнома\n" +
        "                ёки маълумотнома-объективка иловага мувофиқ), дипломнинг нусхаси, чет элда ўқиган\n" +
        "                бўлса, дипломи нострификациядан ўтганлигини тасдиқловчи гувоҳнома, олий ёки ўрта махсус, касб-ҳунар\n" +
        "                таълим муассасаларининг битирувчи курсларида таълим олаётганлар бундан мустасно ва паспортнинг электрон\n" +
        "                шаклини тизимга бириктириши лозим.",
      text22:
        "Номзод бўш иш ўринлари ҳақидаги эълонда кўрсатилган лавозимларнинг фақат биттасини танлаш ва\n" +
        "                танланган лавозим бўйича танловда иштирок этиши мумкин.",
      text23:
        "Бир вақтнинг ўзида бир нечта лавозимга ҳужжат топширишга йўл қўйилмайди.",
      text24: "Тест синови",
      text25:
        "Тест саволлари 30 тадан савол, ҳар бир саволга 4 та (“А”, “B”, “C”, “D”) жавоблардан иборат. Тест синови\n" +
        "                vacancy.adliya.uz сайтидаги шахсий кабинет орқали амалга оширилади.",
      text26: "Тест саволларига жавоб бериш учун 30 дақиқа вақт берилади.",
      text27:
        "Ҳар бир тест саволига фақат битта жавоб белгиланиши лозим. Тўғри жавоб учун\n" +
        "                1 балл, жавоб белгиланмаган ёки нотўғри бўлган тақдирда 0 балл қўйилади",
      text28:
        "Тест синови натижасида камида 21 балл тўплаган номзод кейинги босқичга, яъни номзоднинг назарий\n" +
        "                билимлари ва касбий лаёқатини аниқлаш юзасидан суҳбатга чақирилади ва бу ҳақида номзоднинг шахсий\n" +
        "                кабинетига хабарнома жўнатилади.",
      text29: "Суҳбат жараёни",
      text30:
        "Танлов бошлангунга қадар Ишчи орган томонидан номзоддан соғлиғи ҳолати сўралади. Ўзини ёмон ҳис\n" +
        "                қилаётганидан шикоят қилган номзодлар танловга қўйилмайди. Бундай ҳолатда далолатнома тузилади ва унга\n" +
        "                навбатдаги танловда иштирок этиш ҳуқуқи тушунтирилади.",
      text31:
        "Ишчи орган Махсус комиссия аъзолари ва номзодларга вакант лавозимлар ҳақидаги эълон жойлаштирилган\n" +
        "                жой ва сана, ҳужжатларни топшириш муддатлари, танловда иштирок этиш учун келиб тушган аризалар сони,\n" +
        "                шундан рад қилинганлар\n" +
        "                ва уларнинг сабабларини ҳамда танлов куни ҳозир бўлган номзодларнинг рўйхатини ўқиб эшиттиради.",
      text32:
        "Номзоднинг назарий билимлари ва касбий лаёқатини аниқлаш, унинг лавозим касб фаолиятига боғлиқ\n" +
        "                қонунчилик соҳаси, умумий қонунчилик асослари, амалиётда кўп учрайдиган муаммоли ҳолатлар (казуслар)нинг\n" +
        "                ечими бўйича суҳбат ўтказилади.",
      text33:
        "Номзод суҳбат саволларни генерация ахборот тизими орқали тасодифий танлаш йўли билан олади.\n" +
        "                Саволларни ўзгартиришга йўл қўйилмайди.",
      text34:
        "Номзод тушган саволларга жавоб бера олмаса ёки берилган жавоблар асосида номзоднинг билим\n" +
        "                даражасини аниқлашнинг имконияти бўлмаса, Махсус комиссия раисининг рухсати билан қўшимча саволлар\n" +
        "                берилиши мумкин. Қўшимча саволлар олдинги саволларга берилган жавобларни\n" +
        "                аниқлаштириш мақсадида берилиши ва олдинги саволлар доирасидан четга чиқмаслиги лозим.",
      text35:
        "Номзод томонидан берилган жавоблар аниқ, лўнда ва айнан савол мазмуни билан мос бўлиши ҳамда битта\n" +
        "                саволга жавоб бериш давомийлиги икки дақиқадан ошмаслиги лозим. Қўшимча саволлар берилган ҳолатларда\n" +
        "                суҳбат давомийлиги яна ўн дақиқагача узайтирилиши мумкин.",
      text36:
        "Суҳбатда бериладиган саволлар рўйхати Махсус комиссия раиси томонидан тасдиқланиб, вазирликнинг\n" +
        "                расмий веб-сайтида эълон қилинади ҳамда қонунчиликда, шунингдек жамиятнинг ижтимоий-иқтисодий ва сиёсий\n" +
        "                ҳаётида бўлаётган муҳим ўзгаришлардан келиб чиққан ҳолда ҳар йили янгилаб борилиши мумкин.",
      text37:
        "Суҳбат натижалари бўйича ҳар бир савол ўн баллик тизимда баҳоланади.",
      text38: "Жавобларни баҳолаш қуйидаги мезонлар асосида амалга оширилади:",
      text39: "0 балл – саволга жавоб беролмаслик;",
      text40: "1-3 балл – савол бўйича умумий тушунчага эга эмаслиги;",
      text41: "4-7 балл – саволга умумий ёки қисман жавоб бериш;",
      text42: "8-10 балл – саволга тўлиқ ва атрофлича жавоб бериш.",
      text43:
        "Бунда Махсус комиссия аъзоларининг ҳар бири суҳбат натижаси бўйича, ҳар бир савол юзасидан\n" +
        "                талабгорга белгиланган шаклдаги баҳолаш варақасига балл қўяди. Махсус комиссиянинг ҳар бир аъзоси\n" +
        "                алоҳида баҳолаш варақасини тўлдиради. Баҳолаш варақасини комиссиянинг бошқа аъзоларига кўрсатиш\n" +
        "                тақиқланади ва балларни ўзгартиришга йўл қўйилмайди.",
      text44:
        "Суҳбат якунлари бўйича комиссия аъзолари томонидан номзодга қўйилган баллар умумлаштириш ва ўртача\n" +
        "                балл ҳисоблаб чиқариш учун Ишчи органга берилади. Ишчи орган томонидан номзодга қўйилган баллар\n" +
        "                белгиланган шаклдаги жавоблар варақасига қайд қилинади.",
      text45:
        "Номзод томонидан тўпланиши мумкин бўлган энг юқори баллнинг 56 фоизи\n" +
        "                ва ундан юқорисини тўплаганда номзод лавозимга тавсия этилади. Номзод томонидан тўпланиши мумкин бўлган\n" +
        "                энг юқори баллнинг 55 фоизидан кам балл тўплаганда комиссия аъзолари томонидан номзод суҳбатдан ўтмаган\n" +
        "                деб эътироф этилади.",
      text46:
        "Махсус комиссия суҳбат натижасига мувофиқ номзодни топширган вакант лавозимдан бошқа бир вакант\n" +
        "                лавозимга ишга қабул қилишга тавсия қилиш ҳуқуқига эга.",
      text47:
        "Номзод томонидан тўпланган баллар, баҳолаш натижалари ҳамда комиссия қарори шу куннинг ўзида\n" +
        "                танловда иштирок этган номзодларга ўқиб эшиттирилади.",
      text48:
        "Номзод томонидан тўпланган баллар, баҳолаш натижалари ҳамда комиссия қарори шу куннинг ўзида\n" +
        "                танловда иштирок этган номзодларга ўқиб эшиттирилади.",
      text49: "Номзоднинг шикоят қилиш ҳуқуқи",
      text50:
        "Танлов натижаларидан норози бўлган номзод ўн кун муддат ичида адлия вазирига, шунингдек судга шикоят\n" +
        "                билан мурожаат қилиши мумкин.",
      text51:
        "Танлов тартиби бузилган такдирда ёки коррупция ҳолатлари ҳақида хабарларни Адлия вазирлигининг\n" +
        "                “1008” ишонч телефонига ёки @antikorbot телеграм каналига мурожаат қилишингиз мумкин.",
    },
    getconfirmCode: "Отправка",
    phone: "Телефон",
    title: "Регистрация",
    firstName: "Имя",
    lastName: "Фамилия",
    username: "Имя пользователя",
    password: "Пароль",
    confirmPassword: "Подтвердите Пароль",
    email: "Эл. адрес",
    confirmCode: "Kод подтверждения",
    passport: "Серия и номер паспорта",
    next: "Следующий",
  },
  actions: {
    usernameError: "Пробелы нельзя вводить!",
    tests: "Список тестов",
    print: "Распечатать",
    enteredEmail: "Введите адрес электронной почты",
    enterPhone: "Введите свой номер телефона",
    changeInfo: "Ввод данных",
    read: "O'qish",
    download: "Скачать",
    uploadDiplom: "Загрузить диплом",
    uploadObyektivka: "Загрузить Объективка",
    select: "Выбирать",
    finishTest: "Закончить тест",
    selectAnnoucement: "Выбрать объявление",
    back: "Назад",
    addQuestion: "Создать вопрос",
    uploadImage: "Загрузить изображение",
    uploadCopy: "Загрузить копию паспорта",
    sendDocument: "Отправить документы",
    send: "Отправить",
    selectVacancy: "Выбрать вакансию",
    sendForConfirmation: "Отправить для подтверждения",
    enterSomeThing: "Введите что-нибудь ..",
    clear: "Очистить",
    displayAll: "Показать все",
    title: "Действия",
    add: "Добавить",
    save: "Сохранить",
    cancel: "Отмена",
    next: "Cледующий",
    prev: "Предыдущая",
    choose_file: "Выберите файл",
    filter: "Фильтр",
    delete: "Удалить",
    update: "Обновлять",
    all: "Все",
    edit: "Редактировать",
    editData: "Редактировать данные",
    choosePhoto: "Выбрать фото",
    selectAll: "Выбрать все",
    createUser: "Создать пользователя",
    selectKey: "Выбрать этот ключ",
    yes: "Да",
    no: "Нет",
    createEmployee: "Создать сотрудника",
    confirm: "Подтверждение",
  },
  error: {
    passport_error: "Серийный паспорт требуется и длина должна быть 2",
    name_error: "Это поле не может быть пустым",
    netToken: "У вас нет ни одного ключа",
    login_error: "Неправильное имя пользователя или пароль",
    already_success: "Siz ro'yhatdan o'tgansiz...",
    netAccess: "Не доступ",
    rankNumber: "Должно быть меньше 22",
    age16: "Должен быть старше 16 лет",
    inn: "Неверный формат INN",
    passportNumber: "Неверный формат ИНПС",
    inps: "Неверный формат номер паспорта",
    title: "Ошибка! ",
  },
  staff: {
    totalStavka: "Общий стаж работы",
    stavka: "Ставка",
    salary: "Зарплата",
    arxiv: "Архив штатного расписания",
    changeReason: "Причина изменения штатного расписания",
    list: "Штатное расписание",
    minSalary: "Минимальная заработная плата",
    position: "Должность",
    typePosition: "Тип Должность",
    workWithDepartments: "Работа с подразделениями",
    workWithPosition: "Работа с должностями",
    staffCount: "Количество штатов",
    status: "Статус",
    vacancy: "Вакансия",
    workLoadStaff: "Загруженность штатов",
    refPosition: "Справочник должностей",
    allowances: "Надбавки",
    ranks: "Разряды",
    tariff: "Тариф",
  },
  menu: "Меню",
  employees: {
    pnfl: "Что такое ПИНФЛ?",
    searchPnfl: "ПИНФЛ?",
    dataPassport: "Получение паспортных данных",
    profileBack: "Вернуться к профилю",
    profile: "Профиль",
    ob: "Объективка",
    passport: "Паспорт",
    endBeginPassport: "Дата окончания и начала паспорта",
    title: "Сотрудники",
    personalCard: "Личная карточка",
    birthDate: "Дата рождения",
    appointmentsTransfers: "Назначения и перемещения",
    rotation: "Ротация сотрудников",
    dismissal: "Увольнениуе сотрудников",
    dismissedList: "Список уволенных  сотрудников",
    fullName: "ФИО",
    language: "Языки",
    language_status: "Cтатус языкa",
    firstName: "Имя(Lotin)",
    lastName: "Фамилия(Lotin)",
    parentName: "Отчество(Lotin)",
    email: "Эл. адрес",
    phone: "Телефон",
    mobilePhone: "Дополнительный телефон",
    address: "Адрес",
    addresss: "Адрес",
    birthAddress: "Место рождения:",
    birthRegion: "Регион рождения ",
    location: "Место жительства",
    placeBirth: "Место рождения",
    passportId: "Номер паспорта",
    passportGivenDate: "Дата выдачи паспорта",
    passportEndDate: "Дата истечения срока паспорта",
    passportGivenWho: "Кем выдан паспорт",
    inpc: "ПИНФЛ",
    photo: "Фото сотрудника",
    copyPassport: "Копия паспорта",
    manage: "Управление сотрудниками",
    workingDetails: "Рабочие сведения",
    seniority: "Трудовой стаж",
    foreignLang: "Иностранные языки",
    familyMembers: "Члены семьи",
    partyMembership: "Партийность",
    academic_title: "Ученое звание",
    academic_degree: "Ученая степень",
    state_awards: "Государственные награды",
    education: "Образование",
    isHeDeputy: "Является ли депутатом?",
    phones: "Телефоны",
    endDate: "Дата увольнения",
    beginDate: "Дата приема на работу",
    system: "Система",
    whereWorked: "Где и кто работал",
    givenYear: "Данный год",
    dead: "Мертв",
    alive: "Живой",
    reason: "Причина",
  },
  staffing: {
    title: "Штатное расписание",
    totalVacancy: "Всего вакансий",
    totalStaff: "Общий штат",
  },
  orders: {
    title: "Приказы",
    list: "Список приказов",
    number: "Номер приказа",
    date: "Дата приказа",
    type: "Тип приказа",
    summary: "Краткое содержание",
    contractNumber: "Номер трудового договора",
    dateOfEmployment: "Дата приёма на работу",
  },
  certification: {
    title: "Аттестация",
  },
  vacation: {
    title: "Отпуска",
    send: "Отправить в отпуск",
    on: "Сотрудники находящиеся в отпуске",
    plan: "План отпусков",
    labor: "Трудовой отпуск",
    tempAllowance: "Пособие по временной нетрудоспособности",
    withoutPay: "Отпуск без сохранения содержания",
    careChild: "Отпуск по уходу за ребенком",
    nextlabor: "Сотрудники очередного трудового отпуска",
    withoutContent: "Сотрудники без содержания",
    sickWorkers: "Сотрудники на больничном",
    maternity: "Декретный отпуск",
  },
  monitoringEmployees: {
    title: "Мониторинг сотрудников",
  },
  businessTrips: {
    title: "Командировки",
    enterData: "Ввести командировочные данные",
    on: "Сотрудники в командировке",
  },
  awardsAndBonus: {
    title: "Награждения и надбавки",
  },
  recruitment: {
    title: "Прием на работу",
    etap: "Этап",
    pasportData: "Паспортные данные",
    enterpasportData: "Введены паспортные данные",
    degreeEducation: "Степень образования",
    seniority: "Трудовой стаж",
    familyMembers: "Члены семьи",
    additionalData: "Дополнительная информация",
  },
  departments: "Отделы",
  references: {
    accept: "Принятие",
    regions: "Место рождения",
    exactAdress: "Временное проживание",
    propis: "Постоянное место жительства",
    title: "Объективка",
    all: "Все справочники",
    holiday: "Праздники",
    nationality: "Национальность",
    rectal: "Ректальное",
    spec_diplom: "Спец диплом",
    news: "Новости",
    country: "Страна",
    department_type: "Тип отдела",
    order_type: "Тип заказа",
    work_mode: "Режим работы",
    department: "Отдел",
    holiday_type: "Типы праздников",
    gender: "Пол",
    marital_status: "Семейный статус",
    passport_seria: "Серия паспорта",
    academic_degree: "Ученая степень",
    academic_title: "Ученое звание",
    award: "Награда",
    education: "Образование",
    region: "Регион",
    language: "Язык",
    passportTYpe: "Тип паспорта",
    language_status: "Статус языка",
    military_rank: "Воинское звание",
    party_membership: "Членство в партии",
    reason_for_dismissal: "Причина увольнения",
    educational_institution: "Образовательное учреждение",
    education_type: "Тип образования",
    family_member: "Члены семьи",
    vatInfo: "НДС (%)",
    bankRequesit: "Реквизиты банка",
    bank: "Банк",
    bankAccountType: "Тип аккаунта",
    accountNumber: "Расчетный счет банка",
    depManagement: "Управление подразделением",
    endDate: "Выпускной год",
    directory_phone_type: "Тип телефона",
  },

  name: {
    en: "Nomi(lotin)",
    ru: "Название(русский)",
    uz: "Номи(кирилл)",
    kr: "Qaraqalpaq",
  },
  savol: {
    en: "Savol (lotin)",
    ru: "Вопрос(русский)",
    uz: "Савол(кирилл)",
    kr: "Qaraqalpaq",
  },
  variant: {
    en: "Variant (lotin)",
    ru: "Вариант(русский)",
    uz: "Вариант(кирилл)",
  },
  address: {
    title: "Адрес",
    lt: "Manzil(lotin)",
    ru: "Адрес(русский)",
    uz: "Манзил(кирилл)",
    physical: "Физическое местоположение",
    legal: "Юридическое местоположение",
    phone: "Телефон",
    email: "Эл. адрес",
  },
  userManagement: {
    title: "Управление пользователями",
    roles: "Роли",
    permissions: "Права доступа",
    users: "Пользователи",
  },
  roles: {
    name: "Название",
    code: "Код",
    permissions: "Разрешений",
  },
  permissions: {
    title: "Разрешений",
    name: "Название",
    type: "Тип",
    code: "Код",
    sort: "Сортировать",
  },
  date: "Дата",
  createdDate: "Дата создания",
  confirm_delete: "Вы уверены, что хотите удалить",
  permessionMangement: {
    References: "Справочники",
    Department: "Отделы",
    DirectoryOrder: "Буйруқлар рўйхати",
    // EMPLOYEE

    EmployeeAllowance: "Надбавки",
    EmployeeAcademicTitle: "Ученое звание",
    EmployeeLanguage: "Язык",
    EmployeeAward: "Награда",
    EmployeeRectal: "Ректальное",
    EmployeeWork: "Работа сотрудника",
    Employee: "Сотрудники",
    EmployeeFamilyMember: "Члены семьи",
    EmployeeMemberOfDeputy: "Является ли депутатом?",
    EmployeeAcademicDegree: "Ученая степень",
    EmployeeEducation: "Образование",
    EmployeeHoliday: "Праздники",
    MemberOfDeputy: "Членство в партии",
    EmployeePhoto: "Фото сотрудника",
    EmployeePhoneNumber: "Телефон",
    EmployeeExperience: "Опыт работы",
    EmployeePartial: "Частичный",
    EmployeeWageHistory: "История заработной платы",
    EmployeePassportScan: "Копия паспорта",

    //STAFF
    StaffListCheckAllowance: "Проверить надбавки",
    StaffList: "Штатное расписание",
    StaffPosition: "Должность",
    StaffListChangeReason: "Причина изменения штатного расписания",
    StaffListArchive: "Архив штатного расписания",
    StaffMinSalary: "Минимальная заработная плата",
    StaffListAllowance: "Надбавки",

    //OTHER
    DepartmentAddress: "Адрес отдела",
    TimeSheetControl: "Табель учета рабочего времени",
    BankRequisite: "Реквизиты банка",
    News: "Новости",
    Role: "Роли",
    VATInfo: "НДС (%)",
    User: "Пользователи",
  },
  forgetPasswordText:
    "Введите свои паспортные данные, чтобы мы могли отправить код на ваш зарегистрированный номер телефона:",
  required_error: "Заполните все обязательные поле",
  send_code: "Код был отправлен на ваш номер !",
  success: "Успешно сохранено !",
};
